import { render, staticRenderFns } from "./EditArticleInPending.vue?vue&type=template&id=187fa106&scoped=true"
import script from "./EditArticleInPending.vue?vue&type=script&lang=js"
export * from "./EditArticleInPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187fa106",
  null
  
)

export default component.exports